/** Threshold for `onEndReached` — fires when within 50% of viewport from bottom. */
export const END_REACHED_VIEWPORT_RATIO = 0.5;

/**
 * Dev-only flag. `__DEV__` is injected by Metro on native and by the web
 * bundler; the `typeof` guard keeps this safe if it is ever absent.
 * Avoid `process.env` — it is not defined in the browser.
 */
const isDev = typeof __DEV__ !== "undefined" && __DEV__;

export function warnHeaderConflict() {
  if (isDev) {
    console.warn(
      "[ScreenLayout.Header] `children` overrides convenience props (title / subtitle / onBack / right). Pass one or the other.",
    );
  }
}

export function warnActionsAndPortal() {
  if (isDev) {
    console.warn(
      "[ScreenLayout] <Actions> and <ActionsPortal> are both mounted. Direct <Actions> wins; <ActionsPortal> becomes a no-op host.",
    );
  }
}

export function warnOrphanActionsContent() {
  if (isDev) {
    console.warn(
      "[ScreenLayout.ActionsContent] mounted without an <ActionsPortal> host. Content will not render.",
    );
  }
}
